import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_2.css";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import DefaultData from "../../CompanyData/DefaultData";

const Template_2_Packages = ({ onEnquireClick }) => {
  const companyId = DefaultData.DEFAULTCOMPANYID;
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const getHolidayData = async () => {
      setIsLoading(true);
      try {
        const response = await apiService.getAll(
          `${config.GETPACKAGEBYCOMAPANYID}/${companyId}?type=Holiday`
        );
        setPackages(response.data);
      } catch (error) {
        console.error("Failed to fetch holiday data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getHolidayData();
  }, [companyId]);

  return (
    <section className="Template_2 section Template_2 featured-packages">
      <div className="Template_2 container">
        <div className="Template_2 section-title">
          <h2>Featured Holiday Packages</h2>
          <p>Handpicked experiences for the discerning traveler</p>
        </div>

        {isLoading ? (
          <div className="Template_2 loading">Loading packages...</div>
        ) : packages.length === 0 ? (
          <div className="Template_2 no-data">
            No holiday packages available
          </div>
        ) : (
          <div className="Template_2 packages-grid">
            {packages.slice(0, 8).map((pkg) => (
              <div
                key={pkg.packageId}
                className="Template_2 package-card-container"
              >
                <div className="Template_2 package-card">
                  {/* Front of the card */}
                  <div className="Template_2 package-card-front">
                    <div className="Template_2 package-image">
                      <img src={pkg.imageSrc} alt={pkg.packageName} />
                      <div className="Template_2 package-overlay">
                        <span className="Template_2 package-duration">
                          {pkg.duration}
                        </span>
                      </div>
                    </div>
                    <div className="Template_2 package-content-front">
                      <h3>{pkg.packageName}</h3>
                    </div>
                  </div>

                  {/* Back of the card */}
                  <div className="Template_2 package-card-back">
                    <div className="Template_2 package-content-back">
                      <h3>{pkg.packageName}</h3>
                      <div className="Template_2 package-meta">
                        <span>
                          <i className="fas fa-user-friends"></i>{" "}
                          {pkg.noOfPersons} Persons
                        </span>
                      </div>
                      <div className="Template_2 package-price">
                        {pkg.price ? `INR ${pkg.price}` : "Contact for price"}
                      </div>
                      <button
                        className="Template_2 enquire-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          onEnquireClick(pkg);
                        }}
                      >
                        Enquire Now
                      </button>
                      <div
                        className="Template_2 view-details-link"
                        onClick={() =>
                          navigate(
                            `/template_2_packagedetails/${pkg.packageId}`
                          )
                        }
                      >
                        View Details
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_2_Packages;
